module.exports = __webpack_public_path__ + "img/xyaf.fb552afb.jpg";